export const pushNotificationSettings = {
    // push notification
    authorization: 'key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha',
    urlFCM: "https://fcm.googleapis.com/fcm/send",
    icone: "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
    link: "",
    sound: "default"
}

export const pushProperties = {
    // push notification aplicativo aberto / Forecast
    exibirPush: false,
    title: null,
    body: null,
    link: ""
}

export const usersData = {
    // push notification aplicativo aberto / Forecast
    usuarios: null, // todos usuários e propriedades
    slugUsuariosPorTurma: null // lista de slugs dos usuarios da escola da mesma turma do usuário logado // Usuarios pertencentes a mesma turma do usuário logado
}


export const userProperties = {
    loaded: false,
    perfil: null, //null = não setado / 1 = admin / 2 = Escola / 3 = Administrativo(Cadastra conteudo mas não cria usuarios) / 4 - Administrativo e Professor / 5 - Professor / 6 - Pais / 7 - alunos
    slug: null,
    imagem: null, // slug + . + extensao
    extensao: null,
    nome: null,
    escolaID: null, // Ao criar o usuário não consigo salvar essa valor no banco pois só obtemos o valor no login do usuario, ao realizar o primeiro login nós salvamos esse valor no banco de dados
    alunos: null, //{"aluno1":"idAluno1", "aluno2":"idAluno2"},
    responsaveis: null, //{"aluno1":"idAluno1", "aluno2":"idAluno2"},
    turmas: null,
    dataNascimento: null,
    dataVencimentoMensal: null,
    celular: null,
    tokenFMC: null
}

export const globalProperties = {
    exibirAlertaMedicacao: false
}

// Cache de alguns objetos para otimizar performance
export const cache = {
    home: false, // se a propriedade home for igual a false, faz consulta no banco, se não, consulta do cache
    homeObj: [] // objeto com o cache
}

//import { propertiesLoaded, userProperties } from './global.js'



